import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {standardRetry} from '@emm/core/util/rx.util';
import {MenuDateUtil} from '@emm/core/util/menu-date.util';


@Injectable({
    providedIn: 'root',
})
export class MasterMenuSystemService {

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}

    public getAllCategories(consumer: any): Observable<any> {
        return this.http.get(`${this.apiUrl}/master-menu/menu/v4/template/CHAIN/${consumer}`).pipe(
            map((response: any) => response.items),
            standardRetry()
        );
    }

    public getRevotes(): Observable<any[]> {
        return this.http.get(`${this.apiUrl}/mms-revotes`).pipe(
            map((response) => response),
            standardRetry());
    }

    public getRevote(id): Observable<any[]> {
        return this.http.get(`${this.apiUrl}/mms-revotes/${id}`).pipe(
            map((response) => response),
            standardRetry()
        );
    }

    public updateRevote(id, updatedRevote): Observable<any[]> {
        return this.http.put(`${this.apiUrl}/mms-revotes/${id}`, updatedRevote).pipe(standardRetry());
    }

    public deleteRevote(id): Observable<any[]> {
        return this.http.delete(`${this.apiUrl}/mms-revotes/${id}`).pipe(standardRetry());
    }

    public saveRevote(revote): Observable<any> {
        return this.http.post(this.apiUrl + '/mms-revotes', revote, { responseType: 'json' })
            .pipe(standardRetry());
    }

    // Return menu template selections for a location
    public getMenuSelectedOptionsByLocation(locationNumber: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/master-menu/menu/v4/selection/${locationNumber}?options=true`).pipe(
            map((response: any) => response),
            standardRetry()
        );
    }

    // Return menu template selections for a location
    public getMenuSelectionOptionsByLocation(locationNumber: string) {
        return this.http.get(`${this.apiUrl}/master-menu/menu/v4/template/${locationNumber}`).pipe(
            map((response: any) => response),
            standardRetry()
        );
    }

    // Save menu template options for a location
    public saveSelectedOptions(selected, locationNumber: string, selectedEffectiveDate) {
        if (MenuDateUtil.isToday(selectedEffectiveDate) || selectedEffectiveDate === null) {
            return this.http.post(`${this.apiUrl}/master-menu/menu/v4/selection/${locationNumber}`, selected);
        } else {
            const effectiveDate = MenuDateUtil.formatDateToMidnight(selectedEffectiveDate);
            // tslint:disable-next-line:max-line-length
            return this.http.post(`${this.apiUrl}/master-menu/menu/v4/selection/${locationNumber}?effectiveDate=${effectiveDate}`, selected);
        }
    }
}
